type CashAccount = { __typename: 'CashAccount' };
type DirectTradingAccount = { __typename: 'DirectTradingAccount' };
type ManagedAccount = { __typename: 'ManagedAccount' };

type InvestingAccount = DirectTradingAccount | ManagedAccount;
type Account = CashAccount | DirectTradingAccount | ManagedAccount;

function isCashAccount(account: Account): account is CashAccount {
  return account.__typename === 'CashAccount';
}
function isDirectTradingAccount(account: Account): account is DirectTradingAccount {
  return account.__typename === 'DirectTradingAccount';
}
function isManagedAccount(account: Account): account is ManagedAccount {
  return account.__typename === 'ManagedAccount';
}

export function accountsByType<T extends Account>(accounts: T[]) {
  const cashAccounts: Extract<T, CashAccount>[] = [];
  const investingAccounts: Extract<T, InvestingAccount>[] = [];

  accounts.forEach(account => {
    if (isCashAccount(account)) {
      cashAccounts.push(account as Extract<T, CashAccount>);
    } else if (isDirectTradingAccount(account)) {
      investingAccounts.push(account as Extract<T, InvestingAccount>);
    } else if (isManagedAccount(account)) {
      investingAccounts.push(account as Extract<T, InvestingAccount>);
    }
  });

  return { cashAccounts, investingAccounts };
}
